import React from 'react';
import { inject, observer } from 'mobx-react';
import { toJS } from 'mobx';
import { Row, Col, Spin, Select, Pagination, Affix } from 'antd';
import Tab from '../home/tab/index';
import Cards from '../home/cards/index';
import AppApplyModal from '../util/AppApplyModal';
import CaseApply from '../util/caseApply';
import Portal from '../main/Portal';
import ApplyApp from '../util/appApply/index';
import SingleEcodeWf from '../main/SingleEcodeWf';
import validate from '../util/appApply/validate';
import isEqual from 'lodash/isEqual';
import SearchList from '../util/SearchList';
import util from "../../util";

const {
  checkLicense,
} = validate;

const { 
  getAccessToken
} = util;

const { Option } = Select;

const store = [
  'modeListStore',
  'listStore',
  'homeStore',
  'themeListStore',
  'mainStore',
  'caseListStore',
  'ecodeWfStore',
];

@inject(...store)
@observer
class App extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      searchValue: '',
    }
  }

  componentDidMount() {
    this.clearAll();
    this.callApis();
  }
  componentWillUnmount() {
    this.clearAll();
    const { listStore: { setMobxState } } = this.props;
    setMobxState({ searchValueInfo: "" });
  }
  clearAll = () => {
    const {
      themeListStore: { clear },
      homeStore: { clearAppHot, initAllDatas },
      mainStore: { init, clear: clearMain },
      caseListStore: { clear: clearCase },
      ecodeWfStore: { clear: clearWf },
      listStore: { setMobxState, params: { searchValue } }
    } = this.props;
    setMobxState({ searchValueInfo: searchValue });
    initAllDatas();
    clearAppHot();
    init();
    clearMain();
    clear();
    clearCase();
    clearWf();
  }
  callApis = (loading = true) => {
    const {
      listStore: { params: { searchValue } },
      homeStore: { getAllData, globalSearchList },
    } = this.props;
    // getDemoType();
    searchValue == "" ? getAllData({}, loading) : globalSearchList({title: searchValue}, loading);
    // getAllData({}, loading);
  }
  
  getCount = () => {
    const {
      homeStore: { allDatas },
    } = this.props;
    let listCount = 0;
    Object.keys(allDatas).forEach(key => {
      listCount += allDatas[key].length;
    })
    return {
      listCount,
    }
  }
  
  openForm = (item, type) => {
    const { modeListStore: { getAppDetail }, homeStore: { view } } = this.props;
    if (type === 'mode' || type === 'dev' || type === 'nStandard') {
      getAppDetail({ id: item.sw_id }).then((data) => {
        view(data.app);
        // window.open('http://203.110.166.60:8088/login/login4wf.jsp?userid=1&gopage=' +
        // `/cloudstore/system/index.jsp#/${data.app.s_number}/set`);
      });
    } else {
      // window.open("http://203.110.166.54:8085/login/login4wf.jsp?userid=1&showbtn=0&gopage=/workflow/request/AddRequest.jsp?workflowid=" + item.s_wfid);
    }
  }
  onClick = (item, isApp, typeParams) => {
    const { mainStore: { routing }, homeStore: { setType } } = this.props;
    if (isApp) {
      routing.push(`/app/appDetail/${item.sw_id}`);
      setType(typeParams.id, typeParams.name);
    } else {
      // window.open("http://203.110.166.54:8085/login/login4wf.jsp?userid=1&showbtn=0&gopage=/workflow/request/AddRequest.jsp?workflowid=" + item.s_wfid);
    }
  }
  onCollect = (item, type) => {
    const { homeStore } = this.props;
    homeStore.callCollect({ s_ids: item.sw_id }, type, item.tms_iscoll === '1' ? 'collect' : 'remove');
  }
  onApply = (item) => {
    const { homeStore } = this.props;
    homeStore.callApply({ sw_id: item.sw_id, s_id: item.s_id }, [{ appId: item.s_number, appName: item.s_name }]);
  }
  apply = (item, type) => {
    const { mainStore: { setMobxState }, modeListStore: { getAppDetail } } = this.props;
    getAppDetail({ id: item.sw_id }).then(() => {
      setMobxState({ visibleApply: true, applyType: type });
    });
  }
  download = (id, folderId) => {
    const url = `${window.server}/v5/ecode/download?id=${id}&access_token=${getAccessToken()}`;
    const { ecodeWfStore: { download }  } = this.props;
    download(folderId).then((data) => {
      window.open(url);
      this.callApis(false);
    });
  }
  collection = appId => {
    const { ecodeWfStore: { setStars, starsLoading } } = this.props;
    !starsLoading && setStars({appId}).then(data => data.msg !== '未登录' && this.callApis(false));;
  }
  onStars = id => {
    const { caseListStore: { setStars, starsLoading } } = this.props;
    !starsLoading && setStars({appId: id}).then(data => data.msg !== '未登录' && this.callApis(false));;
  }
  onAppStars = id => {
    const { caseListStore: { setStars, starsLoading } } = this.props;
    !starsLoading && setStars({appId: id}).then(data => data.msg !== '未登录' && this.callApis(false));;
  }
  getMore = (id) => {
    const { 
      mainStore: { routing },
      homeStore: { setType, initTypes },
      modeListStore: { setMobxState, getMould },
    } = this.props;
    const name = initTypes[id];
    setType(id, name);
    setMobxState({ searchType: id, modeType: getMould(id) });
    let pathname = id === 'workflow' ? '/app/list' : name ? '/app' : '/app/search';
    if (id === 'workflowChart') pathname = '/app/workflow';
    routing.push({
      pathname,
      query: {
        id: id,
      }
    });
    window.scrollTo(0, 0);
  }
  onFormChange = (values, allValues) => {
    const { modeListStore: { applyLicense, setMobxState }, mainStore: { appDetail } } = this.props;
    setMobxState({ isApply: false });
    const data = toJS(appDetail);
    if (Object.keys(values).indexOf('license') >= 0) {
      checkLicense(values.license) && applyLicense({
        sw_id: data.sw_id,
        ec_id: allValues.c_id,
        c_id: allValues.c_id,
        ecname: allValues.c_name,
        license: values.license,
      });
    }
  }
  onFormChangeCase = (changed, allValues) => {
    const { caseListStore: { setApply } } = this.props;
    setApply({...changed});
  }
  onFormChangeWfEcode = (changed) => {
    const { ecodeWfStore: { setApply } } = this.props;
    setApply({ ...changed });
  }
  onSelectChange = value => {
    const { homeStore: { setMobxState, initPage } } = this.props;
    setMobxState({ demotype: value });
    initPage();
    this.callApis();
  }
  onPageChange = (pageNum, pageSize) => {
    const { homeStore: { setMobxState } } = this.props;
    setMobxState({ allPageParams: {pageNum, pageSize} });
    this.callApis();
  }
  renderItem = () => {
    const { homeStore: { demoTypeObj, allDatas } } = this.props;
    return Object.keys(allDatas).map(key => {
      const datas = allDatas[key], type = demoTypeObj[key];
      if(datas.length === 0 || isEqual(type)) return null;
      if(type.module === "workflow") return (
        <Col span={20} offset={2} key={key}>
          <Tab simple title={type.desc} span={24} offset={0} getMore={() => this.getMore('workflowChart')} />
          <Row className='ecode-wf-table'>
            {
               datas.map((list) => {
                return <SingleEcodeWf
                  data={list}
                  key={list.id}
                  onChange={() => this.callApis(false)}
                  onDownload={this.download}
                  onStars={this.collection}
                />
              })
            }
          </Row>
        </Col>
      );
      if(type.module === "portal") {
        return (
          <Col span={20} offset={2} key={key}>
            <Tab simple title={type.desc} span={24} offset={0} getMore={() => this.getMore('theme')} />
            <Portal
              themeList={datas}
              apply={this.apply}
              getDatas={() => this.callApis(false)}
            />
          </Col>
        );
      }
      return (
        <Col span={20} offset={2} key={key}>
          <Tab simple title={type.desc} span={24} offset={0} more={false} />
          <Portal
            onStars={this.onAppStars} 
            getDatas={() => this.callApis(false)}
            caseList={datas}
            apply={this.apply}
          />
        </Col>
      )
    });
  }
  render() {
    const { ecodeWfStore, listStore: { searchValueInfo }, homeStore: { demoTypeObj, demotype, allCount, allPageParams } } = this.props;
    const searchCount = this.getCount();
    let { 
      homeStore: { applyModal, applyApps, setMobxState: homeSetMobxState, allDatas, allLoading }, 
      mainStore: { visibleApply, setMobxState },
      caseListStore: { applyVisible, setState },
      ecodeWfStore: { applyVisible: ecodeWfApplyVisible },
    } = this.props;
    applyModal = toJS(applyModal);
    applyApps = toJS(applyApps);
    allDatas = toJS(allDatas);
    // this.renderItem()
    const demoTypeKeys = Object.keys(demoTypeObj);
    return (
      <Row className="search">
        <Col span={20} offset={2} className="search-box">
          {
            searchValueInfo && !allLoading ? 
              <div className="search-info">
                搜索
                <span className="search-info-value">
                  {searchValueInfo}
                </span>
                获得{searchCount.listCount}条数据{/*，以下显示前{searchCount.listCount}条*/}
              </div> : 
              demoTypeKeys.length > 0 && 
              <Row className="case-search-header-list" style={{marginTop: 10}}>
                <SearchList
                  label="应用类型："
                  className={"case-search-header-list-item"}
                  radio
                  labelSpan={3}
                  valueSpan={21}
                  datas={demoTypeKeys.map(key => {
                    return {id: key, typeName: demoTypeObj[key].desc}
                  })}
                  selectKey={demotype}
                  onSelect={this.onSelectChange}
                />
              </Row>
              // <Affix offsetTop={55}>
              //   <Select
              //     showSearch
              //     optionFilterProp="children"
              //     value={demotype}
              //     className="search-select-demotype"
              //     onChange={this.onSelectChange}
              //   >
              //     {
              //       demoTypeKeys.map(key => {
              //         return (
              //           <Option key={key} value={key}>{demoTypeObj[key].desc}</Option>
              //         )
              //       })
              //     }
              //   </Select>
              // </Affix>
          }
        </Col>
        <Col span={24}>
          <Spin wrapperClassName="search-content" spinning={allLoading}>
            {
              searchCount.listCount > 0 ? this.renderItem() :
                <div className="no-data" style={{minHeight: 400, paddingTop: 120}}>
                  <div className="icon-Cloud-No-data" />
                  <p style={{ textAlign: 'center' }}>暂无数据</p>
                </div>
            }
          </Spin>
          {
            allCount > 0 && (
              <Pagination
                className="search-content-page"
                current={allPageParams.pageNum}
                pageSize={allPageParams.pageSize}
                total={allCount}
                showTotal={total => `共${total}条数据`}
                onChange={this.onPageChange}
              />
            )
          }
        </Col>
        <AppApplyModal applyModal={applyModal}
          applyApps={applyApps}
          handleCloseModal={() => {
            homeSetMobxState({ applyModal: { ...applyModal, visible: false } });
          }}
        />
        <ApplyApp
          visible={visibleApply}
          onChange={(v) => setMobxState({ visibleApply: v })}
          onFormChange={this.onFormChange}
          goOrder={this.goOrder}
        />
        <CaseApply visible={applyVisible} onCancel={() => setState({applyVisible: false}) } onFormChange={this.onFormChangeCase} />
        <CaseApply workflowChart visible={ecodeWfApplyVisible} onCancel={() => ecodeWfStore.setState({applyVisible: false}) } onFormChange={this.onFormChangeWfEcode} />
      </Row>
    )
  }
}

export default App


// WEBPACK FOOTER //
// ./src/components/home/AllApp.js